<template>
  <Widget>
    <div slot="head" :wrapperWidth="wrapperWidth">
      <span class="whead-left-title"><span style="color:red">{{wTitle}}</span>配置</span>
    </div>
    <div slot="toolbar">

    </div>
    <Tabs type="card" slot="content">
      <TabPane :label="tab.name" v-for="(tab,index) in tabList" :key="`tab`+index">
        <config-form :configData="tab.systemConfigs" @save="saveConfigForm" :tabId="tab.id"></config-form>
      </TabPane>
    </Tabs>
  </Widget>
</template>
<script>
    import ConfigForm from './configForm';
    import Widget from '@/components/paas/widget';
    export default {
      name: "index",
      components:{ConfigForm,Widget},
      data(){
          return{
            tabList:[],
            serviceUrl:"/eb/system/config",  //每个页面访问后台服务器的路径
            currentIdFiledName: 'id',
            wTitle:'',
            wrapperWidth:'80%',

          }
      },
      created(){
        let type = this.$route.query.type;  //配置类型
        let engTitle = "";
        if(this.$route.query.engTitle && typeof(this.$route.query.engTitle) !== "undefined"){
          engTitle = this.$route.query.engTitle;  //分类字段
        }
        if(type === "system"){
          this.wTitle = "系统"
        }else if(type === "apply"){
          this.wTitle = "应用"
        }else if(type === "pay"){
          this.wTitle = "支付"
        }else{

        }
        this.axios.post(this.$store.state.sysApi+this.serviceUrl+"/renderConfigPageByType?type="+type+"&engTitle="+engTitle).then(res => {
         if(res.code === 200){
            this.tabList = res.data.systemConfigTabs;
          }
        }).catch(error => {
          this.$Message.info("数据获取失败")
        });
      },
      methods:{
        saveConfigForm(data){
        
          this.axios.post(this.$store.state.sysApi+this.serviceUrl+"/saveSystemConfig",data).then(res => {
            if(res.code === 200){
              this.$Message.info("数据保存成功")
            }
          }).catch(error => {
            this.$Message.error("数据保存失败")
          });
        }
      }
    }
</script>

<style scoped>

</style>
